import React from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Resend({ onResend }) {
  const t = useTranslation()

  return (
    <p className="ai-sign-in-modal__resend cgt-body-base">
      {t('signIn.code.resendPrompt')}
      {' '}
      <button
        type="button"
        className="ai-sign-in-modal__switch-link cgt-link-primary-accented"
        onClick={onResend}
      >
        {t('signIn.code.resendAction')}
      </button>
    </p>
  )
}

Resend.propTypes = {
  onResend: func.isRequired,
}

export default Resend
